<template>
<div class="page">
  <div class="header">
    <Header activeMenuIndex="-1"></Header>
  </div>
<!--    <div class="page-header">-->
<!--        <div class="inner">-->
<!--            <div class="left">-->
<!--                <h1 class="logo" @click="$router.push({name:'home'})">-->
<!--                    <img :src="require('@/assets/img/logo.svg')" class="img" />-->
<!--                </h1> -->
<!--                <div class="menu-wrapper"></div>-->
<!--            </div>-->
<!--            <div class="extra">-->
<!--                <el-button size="mini" type="primary" style="margin-right:12px;" @click="goOut">{{ $t("lang.logout") }}</el-button>-->
<!--                &lt;!&ndash; <el-avatar class="avatar" icon="el-icon-user-solid" :size="28"></el-avatar> &ndash;&gt;-->
<!--                <rev-avatar></rev-avatar>-->
<!--                <div class="lang">-->
<!--                    <el-select v-model="Language" size="mini" @change="handleChange">-->
<!--                        <el-option label="English" value="en"></el-option>-->
<!--                        <el-option label="日本語" value="ja"></el-option>-->
<!--                        <el-option label="한국어" value="ko"></el-option>-->
<!--                        <el-option label="繁體中文" value="cn"></el-option>-->
<!--                    </el-select>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
    <div v-if="noticeLists.length >0">
        <van-notice-bar left-icon="volume-o" :scrollable="false" @click="$router.push({name:'userFeedback'})" >
            <van-swipe  vertical  class="notice-swipe"  :autoplay="3000" :show-indicators="false" >
                <div v-for="(item, index) in noticeLists" :key="'item_' + index">
                    <van-swipe-item  v-html="item.clearHtmlMsgContent"></van-swipe-item>
                </div>
            </van-swipe>
        </van-notice-bar>
    </div>
    <div class="page-body">
        <div class="container">
            <div class="aside">
                <div class="aside-menu">
                    <!-- <div class="menu-item" :class="{'active':index==menuActive}" @click="goto(index)" v-for="(item, index) in menuList" :key="'menu_item_'+index">
                        <i class="item-icon">
                            <img class="img" :src="item.icon" />
                        </i>
                        <span class="item-text">{{ item.name }}</span>
                    </div> -->
                
                    <div class="menu-item" @click="goto(0)">
                        <i class="item-icon">
                            <img class="img" :src="require('@/assets/img/account_home.svg')" />
                        </i>
                        <span class="item-text">{{$t("lang.Dashboard")}}</span>
                    </div>
                    <div class="menu-item" @click="goto(5)">
                        <i class="item-icon">
                            <img class="img" :src="require('@/assets/img/account_personalcard.svg')" />
                        </i>
                        <span class="item-text">{{$t("lang.Identification")}}</span>
                    </div>
                    <div class="menu-item" @click="goto(1)">
                        <i class="item-icon">
                            <img class="img" :src="require('@/assets/img/account_security_user.svg')" />
                        </i>
                        <span class="item-text">{{$t("lang.Security")}}</span>
                    </div>
                    <div class="menu-item"   @click="goto(2)">
                        <i class="item-icon" >
                            <img class="img" :src="require('@/assets/img/account_buy_crypto.svg')" />
                        </i>
                        <span class="item-text" :class="{'active':!enabledRecharge}" >{{$t("lang.Payment")}}</span>
                    </div>
                    <div class="menu-item" @click="goto(3)">
                        <i class="item-icon">
                            <img class="img" :src="require('@/assets/img/account_wallet.svg')" />
                        </i>
                        <span class="item-text">{{$t("lang.Fund")}}</span>
                    </div>
                    <div class="menu-item"  @click="goto(4)">
                        <i class="item-icon"> 
                            <img class="img" :src="require('@/assets/img/account_money_send.svg')" />
                        </i>
                        <span class="item-text" :class="{'active':!enabledWithdrawal}">{{$t("lang.withdrawCrypto")}}</span>
                    </div>
                    <div class="menu-item" @click="goto(6)">
                        <i class="item-icon">
                            <img class="img" :src="require('@/assets/img/account_wallet.svg')" />
                        </i>
                        <span class="item-text">{{$t("lang.Transaction")}}</span>
                    </div>
                    <div class="menu-item" @click="goto(7)">
                        <i class="item-icon">
                            <img class="img" :src="require('@/assets/img/account_wallet.svg')" />
                        </i>
                        <span class="item-text">{{$t("lang.announcement")}}</span>
                    </div>
                    <div class="menu-item" @click="goto(8)">
                        <i class="item-icon">
                            <img class="img" :src="require('@/assets/img/account_wallet.svg')" />
                        </i>
                        <span class="item-text">{{$t("lang.feedback")}}</span>
                    </div>
                    <div class="menu-item" @click="goto(9)">
                        <i class="item-icon">
                            <img class="img" :src="require('@/assets/img/account_wallet.svg')" />
                        </i>
                        <span class="item-text">{{$t("lang.teamwork")}}</span>
                    </div>
                </div>
            </div>
            <div class="main">
                <router-view></router-view>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import revAvatar from "@/components/avatar";
import EventBus from '@/utils/EventBus';
import {BASE_GLOB_API} from "@/config.js";
import {axiosPut,axiosPost,axiosGet} from "@/api/api";
import Header from "@/components/header.vue";
export default {
    name:'account',
    components:{Header, revAvatar},
    data(){
        return {
            logout:BASE_GLOB_API+'/login/logout',
            notice:BASE_GLOB_API+'/notice/page',
            Language: "en",  
            menuList:[
                // {name:'Dashboard', icon:require('@/assets/img/account_home.svg')},
                // {name:'Security', icon:require('@/assets/img/account_security_user.svg')},
                // {name:'Identification', icon:require('@/assets/img/account_personalcard.svg')},
                // {name:'Payment', icon:require('@/assets/img/account_buy_crypto.svg')},
                // {name:'Fund', icon:require('@/assets/img/account_wallet.svg')},
                // {name:'Withdrawal', icon:require('@/assets/img/account_money_send.svg')},
                // {name:'Transaction', icon:require('@/assets/img/account_note.svg')}
            ],
            menuActive:0,
            enabledRecharge:true,
            enabledWithdrawal:true,
            noticeLists:[]
        }
    },
    created(){
        let lang = sessionStorage.getItem("Language")
        if(lang){
          this.Language = lang
        }
        // this.menuList=[
        //         {name:this.$t("lang.Dashboard"), icon:require('@/assets/img/account_home.svg')},
        //         {name:this.$t("lang.Security"), icon:require('@/assets/img/account_security_user.svg')},
        //         // {name:this.$t("lang.Identification"), icon:require('@/assets/img/account_personalcard.svg')},
        //         {name:this.$t("lang.Payment"), icon:require('@/assets/img/account_buy_crypto.svg')},
        //         {name:this.$t("lang.Fund"), icon:require('@/assets/img/account_wallet.svg')},
        //         {name:this.$t("lang.Withdrawal"), icon:require('@/assets/img/account_money_send.svg')},
        //         // {name:this.$t("lang.Transaction"), icon:require('@/assets/img/account_note.svg')}
        //     ]
        // this.menuActive=0
        // this.$router.push({name:"dashboard"})
        EventBus.$on('enabledRecharge', value => {
    
           this.enabledRecharge =value;
        })
        EventBus.$on('enabledWithdrawal', value => {

           this.enabledWithdrawal =value;
           
        })
        this.noticeList(1,10)
    },
    methods:{
        noticeList(pageNo,pageSize){
            let params = {
                pageNo:pageNo,
                pageSize:pageSize,
                query:{
                    readStatus:0,
                    // noticeType:1
                }
            }
            axiosPost(this.notice,params).then(res=>{
               if(res.code ==200){
                this.noticeLists =res.result.records
               }else{
                    this.$message.error(res.message);
                }
            })
        },
        goOut(){
            axiosGet(this.logout).then(res=>{
               if(res.code ==200){
                this.$router.push({name:'login'});
                window.sessionStorage.clear();
                window.localStorage.clear();
                EventBus.$emit('share',  this.Language);
               }else{
                    this.$message.error(res.message);
                }
            })
        },
       
        handleChange() {
            this.$i18n.locale = this.Language;
            sessionStorage.setItem("Language", this.Language);
            EventBus.$emit('share',  this.Language);
            // this.menuList=[
            //     {name:this.$t("lang.Dashboard"), icon:require('@/assets/img/account_home.svg')},
            //     {name:this.$t("lang.Security"), icon:require('@/assets/img/account_security_user.svg')},
            //     // {name:this.$t("lang.Identification"), icon:require('@/assets/img/account_personalcard.svg')},
            //     {name:this.$t("lang.Payment"), icon:require('@/assets/img/account_buy_crypto.svg')},
            //     {name:this.$t("lang.Fund"), icon:require('@/assets/img/account_wallet.svg')},
            //     {name:this.$t("lang.Withdrawal"), icon:require('@/assets/img/account_money_send.svg')},
            //     // {name:this.$t("lang.Transaction"), icon:require('@/assets/img/account_note.svg')}
            // ]
        },
        goto(index){
            console.log("index", index)
            // if(index ==-1){
            //     this.$router.push({name:"center"})
            // }
            if(index ==0){
                this.$router.push({name:"dashboard"})
            }
            if(index ==1){
                this.$router.push({name:"security"})
            }
            if(index ==2){
                if(this.enabledRecharge){
                    this.$router.push({name:"payment"})
                }
              
            }
            if(index ==3){
                this.$router.push({name:"fund"})
            }
            if(index ==4){
                if(this.enabledWithdrawal){
                    this.$router.push({name:"withdrawal"})
                }
                
            }
            if(index ==5){
                this.$router.push({name:"identification"})
                
            }
            if(index ==6){
                this.$router.push({name:"transaction"})
            }
            if(index ==7){
                this.$router.push({name:"userFeedback"})
            }
            if(index ==8){
                this.$router.push({name:"Feedback"})
            }
            if(index ==9){
                this.$router.push({name:"teamwork"})
            }
            // this.$router.push({name:name.toLowerCase()})
            this.menuActive = index;
        }
    }
}
</script>
<style lang="less" scoped>
.page {
    .page-header {
        margin-bottom:2px; background:#fff; border-bottom:#e6e6e6 1px solid; box-shadow:0 0 8px rgba(0,0,0,.1);
        .inner {
            width:80%; min-width:1200px; margin:0 auto; height:50px; display:flex; justify-content: space-between; align-items: center;
            .left {
                .logo {
                    .img {
                        height:48px;
                    }
                }
                .menu-wrapper {}
            }
            .extra {
                display:flex; justify-content: flex-end; align-items: center;
                .avatar {margin-left:10px;}
                .lang {width:100px; margin-left:10px;}
            }
        }
    }
    .notice-swipe {
        height: 40px;
        line-height: 40px;
    }
    .page-body {
        padding:50px 0;
        .container {
            width:80%; min-width:1200px; margin:0 auto; display:flex; justify-content: space-between; align-items: flex-start;
            .aside {
                width:220px; margin-right:40px;
                .aside-menu {
                    .menu-item {
                        height:40px; line-height:24px; padding:8px 12px; background:transparent; border-radius:4px; margin:0 0 5px; cursor: pointer;
                        display:flex; justify-content: flex-start; align-items: center;
                        .item-icon {
                            margin-right:6px; display:block;
                            .img {
                                width:16px; height:16px; display:block; color:#999;
                            }
                        }
                        .item-text {
                            font-weight:700; color:#666;
                            &.active{
                                color:#ccc;
                        }
                        }
                        &.active, &:hover {
                            background:#f4f5f6;
                        }
                    }
                }
            }
            .main {
                flex:1;
            }
        }
    }
}
</style>